import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { usePlans } from "../../RegularPlan/PlansContext";
import { PlanCard } from "./PlanCard";

export const VerticalPlanCardList = () => {
  const { plans, isPlansLoading } = usePlans();

  if (isPlansLoading) {
    return <SkeletonLoader variant="vertical-plan-card" cardCount={3} />;
  }

  const basic = plans.find(plan => plan.tier === "basic");
  const rest = plans.filter(plan => plan.tier !== "basic");

  const plansToRender = basic ? [...rest, basic] : plans;

  return (
    <div className="mt-5 flex flex-col flex-wrap items-center justify-around gap-2 md:flex-row">
      {plansToRender.map(plan => (
        <div key={plan.id}>
          <PlanCard plan={plan} />
        </div>
      ))}
    </div>
  );
};
